import React from 'react';

interface Props {
  className?: string;
  height?: number;
  width?: number;
  color?: string;
}

export const ChevronDown = ({
  className = 'chevron-down-icon',
  height = 24,
  width = 24,
  color = 'currentColor',
}: Props) => (
  <svg
    data-testid="chevron-down-icon"
    className={className}
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.44922 9.58027L6.50922 8.53027L11.8092 13.9003C11.8692 13.9603 11.9392 13.9703 11.9792 13.9703C12.0192 13.9703 12.0992 13.9703 12.1592 13.9003L17.4792 8.53027L18.5392 9.58027L13.2292 14.9503C12.8992 15.2903 12.4592 15.4703 11.9792 15.4703C11.4992 15.4703 11.0692 15.2903 10.7392 14.9503L5.44922 9.58027Z"
      fill={color}
    />
  </svg>
);
